const commentsModule = {
    initEvents () {
        $(document).on('click', '.reply-btn', function () {

            const author = this.dataset.commentAuthor;
            const comment = this.dataset.commentContent;
            const comment_parent = +this.dataset.commentId;

            $('.block-add-comment:not(.new-comment)').remove();

            $(this).after(`
                <div class="block-add-comment">
                    <form action="" data-comment-form>
                        <input type="hidden" name="comment_parent" value="${comment_parent}">
                        <div class="block-add-comment__answer">
                            <div class="block-add-comment__responding">
                                <div class="block-comments__user-name">
                                    <div>
                                        <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7 4V0L0 7L7 14V9.9C12 9.9 15.5 11.5 18 15C17 10 14 5 7 4Z" fill="#747474"/>
                                        </svg>
                                    </div>
                                    <div>${translates.reply_on_comment} ${author}</div>
                                </div>
                                <div class="block-add-comment__cancel-block">
                                    <div data-cancel-reply>${translates.cancel}</div>
                                    <div>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8 16L16 8" stroke="#AEAEAF" stroke-width="2" stroke-linecap="round"/>
                                            <path d="M16 16.0005L8 8.00049" stroke="#AEAEAF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
<!--                            <div class="block-add-comment__question">${comment}</div>-->
                        </div>

                        <div class="block-add-comment__desc">${translates.other_user_see_name}</div>
                        <div class="block-add-comment__input-block">
                            <div class="block-add-comment__input-wrapper">
                                 <input type="text" placeholder="${translates.name} *" name="author" required>
                                <div class="obligatory-field">${translates.require_field}
                                     <img src="/wp-content/themes/crypto/dist/images/content/arrows-icons/corner.svg" alt="">
                                </div>
                            </div>
                            <div class="block-add-comment__input-wrapper">
                                  <input type="email" placeholder="${translates.email} *" name="email" required>
                                  <div class="obligatory-field">${translates.require_field}
                                      <img src="/wp-content/themes/crypto/dist/images/content/arrows-icons/corner.svg" alt="">
                                  </div>
                            </div>
                        </div>
                        <div class="block-add-comment__textarea-wrapper">
                            <textarea class="block-add-comment__comment" name="comment" placeholder="${translates.comment} *" required></textarea>
                            <div class="obligatory-field">${translates.require_field}
                                 <img src="/wp-content/themes/crypto/dist/images/content/arrows-icons/corner.svg" alt="">
                            </div>
                        </div>
                        <div class="block-add-comment__text">
                            ${translates.contacts_accept}
                        </div>
                        <div class="block-add-comment__button-block">
                            <button class="comment-submit-btn" type="submit">${translates.submit}</button>
                        </div>
                        <div class="pop-up">
                            <div class="pop-up__img">
                                <img src="/wp-content/themes/crypto/dist/images/content/icons/comment-success.svg" alt="">
                            </div>
                            <div class="pop-up__title">${translates.your_msg_sent}</div>
                            <div class="pop-up__desc">${translates.comment_on_moderation}</div>
                            <button class="pop-up__btn">${translates.understood}</button>
                        </div>
                    </div>
                </form>
            `)
        })
        $(document).on('click', '[data-cancel-reply]', function (e) {
            $(this).closest('.block-add-comment').remove();
        });

        document.addEventListener('invalid', (function(){
            return function(e) {
                e.preventDefault();
                $(e.target).parent().addClass('has-error')
            };
        })(), true);

        $(document).on('submit', 'form[data-comment-form]', function (e) {
            e.preventDefault();

            const formData = $(e.target).serializeArray();
            const commentData = {};

            formData.forEach(field => {
                commentData[field.name] = field.value;
            })

            if(!commentData.author || !commentData.email || !commentData.comment) return false;

            const data = {
                action: 'addComment',
                comment_post_ID: +document.getElementById('comment-post-id').dataset.postId,
                author: commentData.author,
                email: commentData.email,
                comment: commentData.comment,
                comment_parent: commentData['comment_parent'] ? +commentData['comment_parent'] : 0,
            };

            $('.comment-submit-btn').prop('disabled', true);

            $(this).trigger('reset')
            $(this).find('.has-error').removeClass('has-error')

            $.post(ajaxurl, data, () => {
                $(e.target).trigger('reset');
            });

            $(this).closest('.block-add-comment').find('.pop-up').addClass('pop-up-show');
        })
        $(document).on('click', '.pop-up__btn', function (e) {
            e.preventDefault();

            const block = $(this).closest('.block-add-comment');

            if (!block.hasClass('new-comment')) {
                $(this).closest('.block-add-comment').remove();
            } else {
                $(this).closest('.pop-up').removeClass('pop-up-show');
            }

            $('.comment-submit-btn').prop('disabled', false);
        })
    },

    init(){
        this.initEvents();
    }
}

export default commentsModule;
